export class JsonHelper {

  static stringifyOrNull(value: any): string {
    return value ? JSON.stringify(value) : null;
  }

  static parseOrNull(text: string): any {
    return text ? JSON.parse(text) : null;
  }
}
